
  var _styles = {
  "expire-text": {
    "fontSize": "0.26667rem",
    "color": "rgb(153,153,153)",
    "fontWeight": "400",
    "fontFamily": "PingFang SC"
  }
};



  module.exports = _styles;
  